/**
 * デバイスに「ユーザ検証可能な Platform Authenticator」(Windows Hello / Touch ID /
 * Android 生体認証 / Chrome OS PIN 等) が利用可能かを判定する。
 *
 * false の場合、navigator.credentials.create() を呼ぶとブラウザはクロスデバイス
 * 認証 (QR コードでスマートフォン経由) のダイアログを表示する。
 * Windows Hello が未設定の Windows / Linux 等では false が返る。
 *
 * PRODUCT_DEV-396: パスキー登録誘導モーダル / SecurityPage 登録ボタンを
 * QR 経路に進ませないための事前判定として利用する。
 */
export async function isPlatformAuthenticatorAvailable(): Promise<boolean> {
  try {
    if (
      typeof window === "undefined" ||
      typeof window.PublicKeyCredential === "undefined" ||
      typeof window.PublicKeyCredential
        .isUserVerifyingPlatformAuthenticatorAvailable !== "function"
    ) {
      return false;
    }
    return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch {
    return false;
  }
}
